import axios from '@/libs/api.request';

export const getCage = (id) => {
  return axios.request({
    url: 'cage/' + id,
    method: 'get'
  });
};

export const getCageA = (cageNo) => {
  return axios.request({
    url: 'cage/a/' + cageNo,
    method: 'get'
  });
};

export const addCage = (cageNo) => {
  return axios.request({
    url: 'cage/add/' + cageNo,
    method: 'get'
  });
};

export const setCageP = (id, pOut, pIn, aOut, aIn, note) => {
  const data = {
    'p_out': pOut,
    'p_in': pIn,
    'a_out': aOut,
    'a_in': aIn,
    note
  };
  return axios.request({
    url: 'cage/p/' + id,
    data,
    method: 'post'
  });
};

export const scrapCage = (id) => {
  return axios.request({
    url: 'cage/scrap/' + id,
    method: 'get'
  });
};

export const getCageList = ({ kw, out, unout, scrap, page, perPage }) => {
  const data = {
    kw,
    out,
    scrap,
    unout,
    page,
    perPage
  };
  return axios.request({
    url: 'cage/list',
    data,
    method: 'post'
  });
};

export const getCageListP = ({ start, end }) => {
  const data = {
    start,
    end
  };
  return axios.request({
    url: 'cage/list_p',
    data,
    method: 'post'
  });
};

export const getCageNums = () => {
  return axios.request({
    url: 'cage/nums',
    method: 'get'
  });
};

export const getCageHis = ({ cageNo, kw, indate, outdate, unreturn, start, end, page, perPage }) => {
  const data = {
    cageNo,
    kw,
    indate,
    outdate,
    unreturn,
    start,
    end,
    page,
    perPage
  };
  return axios.request({
    url: 'cage/his',
    data,
    method: 'post'
  });
};

export const sendCage = (cages) => {
  const data = {
    cages
  };
  return axios.request({
    url: 'cage/sendcage',
    data,
    method: 'post'
  });
};

export const unsendCage = (cageId) => {
  const data = {
    id: cageId
  };
  return axios.request({
    url: 'cage/unsend',
    data,
    method: 'post'
  });
};

export const returnCage = (cages) => {
  const data = {
    cages
  };
  return axios.request({
    url: 'cage/returncage',
    data,
    method: 'post'
  });
};

export const deReturnCage = (cage_id) => {
  const data = {
    cage_id
  };
  return axios.request({
    url: 'cage/dereturncage',
    data,
    method: 'post'
  });
};
